import { fetchConfig } from '@theme/utilities';
import { CartUpdateEvent } from '@theme/events';

/**
 * ANNI CUSTOM — Warenkorb-Varianten-Selektor.
 *
 * Horizon zeigt Varianten im Warenkorb nur als Read-only-Text. Da der
 * Varianten-Picker auf der PDP entfernt wurde (Kundenwunsch H3), braucht
 * der Kunde hier eine Moeglichkeit, die Groesse zu aendern.
 *
 * Shopifys `change.js` kann die Variante einer Zeile nicht tauschen — also
 * neue Variante adden, alte Zeile entfernen, dann Drawer per CartUpdateEvent
 * neu rendern lassen (gleicher Pfad wie Horizons Mengen-Update).
 */
class AnniCartVariantSelect extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('select');
    this.select?.addEventListener('change', this.onChange);
  }

  disconnectedCallback() {
    this.select?.removeEventListener('change', this.onChange);
  }

  onChange = async () => {
    if (!this.select) return;

    const newId = Number(this.select.value);
    // change.js targetiert die Zeile nur zuverlaessig per String-ID, nicht numerisch.
    const currentId = String(this.dataset.currentId ?? '');
    const quantity = parseInt(this.dataset.quantity ?? '', 10) || 1;

    if (!newId || !currentId || String(newId) === currentId) return;

    const cartItems = this.closest('cart-items-component');
    const sectionId = cartItems instanceof HTMLElement ? cartItems.dataset.sectionId : undefined;

    this.setAttribute('aria-busy', 'true');
    this.classList.add('anni-cart-variant--loading');

    try {
      // 1) Neue Variante adden. Shopify setzt neue Positionen nach OBEN —
      //    deshalb die alte Zeile per Varianten-ID (index-unabhaengig) entfernen.
      await fetch(
        Theme.routes.cart_add_url,
        fetchConfig('json', { body: JSON.stringify({ id: newId, quantity }) })
      );

      // 2) Alte Variante per ID entfernen — finaler Sektions-State im Response.
      const changeResponse = await fetch(
        Theme.routes.cart_change_url,
        fetchConfig('json', {
          body: JSON.stringify({
            id: currentId,
            quantity: 0,
            sections: sectionId,
            sections_url: window.location.pathname,
          }),
        })
      );

      const cart = await changeResponse.json();

      // 3) Horizons eigenen Cart-Update-Pfad ausloesen → Drawer morpht sich neu.
      document.dispatchEvent(
        new CartUpdateEvent(cart, 'anni-cart-variant', {
          source: 'anni-cart-variant',
          sections: cart.sections,
        })
      );
    } catch (error) {
      console.error('[anni-cart-variant]', error);
      window.location.reload();
    }
  };
}

if (!customElements.get('anni-cart-variant-select')) {
  customElements.define('anni-cart-variant-select', AnniCartVariantSelect);
}
